export default __webpack_public_path__ + "static/media/logo-error.4bf8fa75.svg";